var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUpdateAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#0D7EB8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.815 10h-11.63A4.194 4.194 0 0 0 10 14.185v11.63A4.19 4.19 0 0 0 14.185 30h3.321a.865.865 0 0 0 .863-.863.865.865 0 0 0-.863-.863h-3.321a2.463 2.463 0 0 1-2.46-2.459v-11.63a2.463 2.463 0 0 1 2.46-2.46h11.63a2.463 2.463 0 0 1 2.46 2.46v4.15c0 .474.388.863.862.863a.865.865 0 0 0 .863-.863v-4.15A4.19 4.19 0 0 0 25.815 10",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.335 19.965H15.84a.865.865 0 0 0-.862.863c0 .475.388.863.862.863h2.494a.865.865 0 0 0 .863-.863.865.865 0 0 0-.863-.863m-2.484-2.424h7.48a.865.865 0 0 0 .863-.863.865.865 0 0 0-.863-.863h-7.48a.865.865 0 0 0-.863.863c0 .475.388.863.863.863m11.984 3.253a1.714 1.714 0 0 0-2.39 0l-5.228 5.229a.85.85 0 0 0-.25.612v2.494c0 .474.388.862.862.862h2.494a.9.9 0 0 0 .613-.25l5.228-5.254c.32-.32.492-.75.492-1.2 0-.457-.181-.88-.5-1.199l-1.312-1.294zm-4.875 7.48h-1.268v-1.277l4.935-4.978 1.312 1.251z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpdateAction);
export default __webpack_public_path__ + "static/media/ic_update_action.b256282dd3ed79b38e6b3400c3261604.svg";
export { ForwardRef as ReactComponent };